import { createConfigExperiment, getExperiment } from '@pegasus/abtesting';
import { useSelector } from 'react-redux';

const PROJECT_ID = '9df589f0-9668-4a1a-a051-cf499ec1baa8';
const NEW_CCF_IMAGES_CONTROL = 'control_campaignTitle';
const NEW_CCF_IMAGES_VARIANT = 'variant_campaignTitle';

export const useCampaignTitleExperiment = () => {
    // @ts-ignore
    const experiment = useSelector(state => getExperiment(state, PROJECT_ID));

    if (!experiment) {
        return false;
    }

    // @ts-ignore
    return experiment?.variant === NEW_CCF_IMAGES_VARIANT;
};

export default createConfigExperiment({
    projectId: PROJECT_ID,
    variants: [NEW_CCF_IMAGES_CONTROL, NEW_CCF_IMAGES_VARIANT],
});
